import ApiService from "@/common/api.service"

export const ProgramService = {
    create(params) {
        return ApiService.post("programs/add", params);
    },
    update(slug, params) {
        return ApiService.update("/programs", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("/programs", slug, params)
    },
    async getPrograms() {
        const res = await ApiService.get("/programs");
        return res.data;
    },
    async getProgramsWP(page, itemsPerPage, query) {
        let queryParam = query ? `/programs?page=${page}&pageSize=${itemsPerPage}${query}` : `/programs?page=${page}&pageSize=${itemsPerPage}`
        const res = await ApiService.get(queryParam);
        return res.data;
    },
    async getProgramByDate(startDate, endDate) {
        const res = await ApiService.get("/programs/all/byDate/" + startDate + "/" + endDate);
        return res.data;
    }

}
